export class FinalizeChunkedUploadRequest {
  fileUuid!: string;
  fileName!: string;
  countChunks!: number;
}
